import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { CustomLink } from "../../custom-link";
import { sectionPath } from "../../../utils";
import "./story-section.module.css";

export const StorySection = ({ story, config, template = "" }) => {
  const section = get(story, ["sections", 0]);
  const supportedTemplates = ["simple", "background"];
  const templateStyle = supportedTemplates.includes(template) ? `link--${template}` : "link";
  if (!section) return null;
  const mountAtPrefix = config.mountAt || "";
  return (
    <CustomLink
      data-testid="section-name"
      styleName={templateStyle}
      href={`${mountAtPrefix}/` + sectionPath(config, section)}
    >
      {section["display-name"] || section["name"]}
    </CustomLink>
  );
};

StorySection.propTypes = {
  story: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  template: PropTypes.oneOf(["simple", "background"])
};
